
















import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { AdminRoutes } from "@/data/enums/router";

// Types
import { IWebhook } from "@/models/webhooks";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";

@Component
export default class WebhookOverviewView extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => any;

  @Prop({ default: undefined })
  public webhookId!: IWebhook["id"];

  // Methods

  public get breadcrumbs(): ICrumb[] {
    return [
      {
        label: this.$t("_.webhooks"),
        route: {
          to: {
            name: AdminRoutes.WEBHOOKS_SETTINGS
          }
        }
      },
      {
        label: this.$t("_.webhook")
      }
    ];
  }
}
